module.exports = __webpack_public_path__ + "assets/img/img-7.947aa84b.png";